import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=912619a8&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('912619a8')) {
      api.createRecord('912619a8', component.options)
    } else {
      api.reload('912619a8', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=912619a8&", function () {
      api.rerender('912619a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/Badge.vue"
export default component.exports